import { render } from "./KitsDetail.vue?vue&type=template&id=6493d288"
import script from "./KitsDetail.vue?vue&type=script&lang=js"
export * from "./KitsDetail.vue?vue&type=script&lang=js"

import "./KitsDetail.vue?vue&type=style&index=0&id=6493d288&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__